const style = (theme) => {
  const output = {
    root: {
      position: 'relative',
      zIndex: 1,
      width: '100%',
      height: 'auto',
    },
    isFirstTime: {
      '& $poster': {
        pointerEvents: 'none',
        opacity: 0,
      },
    },

    /*------------------------------
    Poster
    ------------------------------*/
    poster: {
      position: 'absolute',
      zIndex: 3,
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      cursor: 'pointer',
      transition: 'opacity .3s ease-out',
      '&:after': {
        position: 'absolute',
        top: 0,
        left: 0,
        display: 'block',
        content: '""',
        height: '100%',
        width: '100%',
        zIndex: 2,
        background: theme.getRgba(theme.colors[0], 0.6),
      },
      '& img': {
        position: 'absolute',
        zIndex: 1,
        width: '100%',
        height: '100%',
        bottom: 0,
        right: 0,
        top: 0,
        left: 0,
        objectFit: 'cover',
        objectPosition: 'center center',
        userSelect: 'none',
        userDrag: 'none',
      },
    },
    button: {
      width: 80,
      height: 80,
      position: 'absolute',
      zIndex: 3,
      top: '50%',
      left: '50%',
      cursor: 'pointer',
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      borderRadius: 58,
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: `all .3s ${theme.easings['power4.out']}`,
      '& svg': {
        fill: theme.colors[1],
        width: '70%',
        transition: `all .3s ${theme.easings['power4.out']}`,
      },
      '&:hover': {
        background: theme.colors[1],
        '& svg': {
          fill: theme.getRgba(theme.colors[0], 0.4),
        },
      },
    },
    // posterPlay: {
    //   position: 'absolute',
    //   zIndex: 1,
    //   top: '50%',
    //   left: '50%',
    //   padding: '18px 30px 18px 80px',
    //   borderRadius: 40,
    //   border: `1px solid ${theme.colors[2]}`,
    //   transform: 'translate(-50%, -20px)',
    //   background: theme.colors[1],
    // },
    // posterPlayIco: {
    //   background: theme.colors[2],
    //   borderRadius: '50%',
    //   width: 58,
    //   height: 58,
    //   display: 'flex',
    //   justifyContent: 'center',
    //   alignItems: 'center',
    //   position: 'absolute',
    //   top: 3,
    //   left: 3,
    //   '& svg': {
    //     width: 30,
    //     height: 30,
    //     fill: theme.colors[1],
    //   },
    // },
    // posterPlayText: {
    //   whiteSpace: 'nowrap',
    //   textTransform: 'uppercase',
    //   color: theme.colors[0],
    //   fontSize: 20,
    // },

    /*------------------------------
    Video
    ------------------------------*/
    video: {
      width: '100%',
      cursor: 'pointer',
      transition: 'opacity .3s ease-out',

      '& video': {
        display: 'block',
        width: '100%',
      },
    },

    /*------------------------------
    Controllers
    ------------------------------*/
    controllers: {
      position: 'absolute',
      padding: [4, 7, 7],
      zIndex: 2,
      bottom: 0,
      left: 0,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      userSelect: 'none',
      paddingTop: 10,
      background:
      `linear-gradient(to top, ${theme.getRgba(theme.colors[0], 0.4)}, ${theme.getRgba(theme.colors[2], 0.001)})`,

      '& button': {
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        padding: 0,
        width: 32,
        height: 32,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        '& svg': {
          fill: theme.colors[1],
          width: '100%',
          height: '100%',
        },
      },
    },

    /*------------------------------
    Progress
    ------------------------------*/
    progressWrap: {
      flex: '1 1 auto',
      height: 40,
      position: 'relative',
      zIndex: 1,
      cursor: 'grab',
      margin: [0, 6],
      '&:hover': {
        '& $progressBall': {
          opacity: 1,
        },
      },
    },
    isDragging: {
      cursor: 'grabbing!important',
    },
    progressPlaceholder: {
      position: 'absolute',
      zIndex: 1,
      top: '50%',
      left: 0,
      width: '100%',
      height: 1,
      background: 'rgba(255, 255, 255, .3)',
    },
    progress: {
      position: 'absolute',
      zIndex: 2,
      top: '50%',
      left: 0,
      width: '100%',
      height: 1,
      background: 'rgba(255, 255, 255, 1)',
      transformOrigin: '0 0',
      transform: 'scaleX(0)',
    },
    progressBall: {
      position: 'absolute',
      zIndex: 1,
      top: 13,
      left: '100%',
      width: 7,
      height: 7,
      background: theme.colors[1],
      borderRadius: '50%',
      opacity: 0,
      transition: 'opacity .2s ease-out',
    },

    /*------------------------------
    Volume
    ------------------------------*/
    volumeWrap: {
      position: 'relative',
      zIndex: 1,
      '&:hover': {
        '& $volumeRange': {
          opacity: 1,
        },
      },
    },
    volumeRange: {
      position: 'absolute',
      top: -3,
      left: 9,
      zIndex: 1,
      transformOrigin: '0 0',
      transform: 'rotate(-90deg)',
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      opacity: 0,
      transition: 'opacity .2s ease-out',
      width: 100,
      height: 7,
      background: 'transparent',
      '&::-webkit-slider-runnable-track': {
        WebkitAppearance: 'none',
        background: theme.colors[1],
        height: '1px',
      },
      '&::-moz-range-track': {
        WebkitAppearance: 'none',
        background: theme.colors[1],
        height: '1px',
      },
      '&:focus': {
        outline: 'none',
      },
      '&::-webkit-slider-thumb': {
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        borderRadius: '50%',
        border: 'none',
        height: '11px',
        width: '11px',
        maxWidth: '80px',
        position: 'relative',
        bottom: '5px',
        backgroundColor: theme.colors[1],
        cursor: 'grab',
        '&:active': {
          cursor: 'grabbing',
        },
      },
      '&::-moz-range-thumb': {
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        border: '2px solid',
        borderRadius: '50%',
        height: '20px',
        width: '20px',
        maxWidth: '80px',
        position: 'relative',
        bottom: '9px',
        backgroundColor: theme.colors[1],
        cursor: 'grab',
        '&:active': {
          cursor: 'grabbing',
        },
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
  }

  return output
}

export default style
